
import Glide, { Autoplay, Controls, Swipe } from '@glidejs/glide/dist/glide.modular.esm'
import "@glidejs/glide/dist/css/glide.core.min.css";

let itemCount =  document.getElementsByClassName('glide__slide').length;
// let start = Math.floor(Math.random() * Math.floor(itemCount));

let pageWidth = window.innerWidth || document.body.clientWidth;
let containerWidth = 1344;

if(pageWidth > 1400) {
  let remaining = pageWidth - containerWidth;
  if(itemCount) {
    new Glide('.glide.verdieping',{
      type: 'carousel',
      // perView: 1,
      // focusAt: 'center',
      autoplay:4000,
      animationDuration: 1000,
      gap:30,
      peek: remaining / 2
      // startAt: start

    }).mount({ Autoplay, Controls })
  }
} else {
  if(itemCount) {
    new Glide('.glide.verdieping',{
      type: 'carousel',
      // perView: 1,
      // focusAt: 'center',
      autoplay:4000,
      animationDuration: 1000,
      gap:30,
      // startAt: start

    }).mount({ Autoplay, Controls, Swipe })
  }
}





